<template>

  <el-container style="height: 100vh;position: relative;">
    <service :serviceInfo_show='serviceInfo_show'></service>

    <!-- 左侧导航 -->
    <el-scrollbar style="height:100%"
                  class="scro_nav">
      <el-row class="tac">
        <el-col :span="12">
          <el-menu :default-active="this.$route.path"
                   class="el-menu-vertical-demo"
                   background-color="#2d2e36"
                   text-color="#fff"
                   active-text-color="#ffd04b"
                   router>
            <div class="logo">
              <!-- <img src="../assets/logo.png" /> -->
            </div>
            <el-submenu :index="this.$route.path">
              <template slot="title">
                <i class="el-icon-s-order"></i>
                <span>订单</span>
              </template>
              <el-menu-item index="/index/placeOrder">快速下单</el-menu-item>
              <!-- <el-menu-item index="/index/pending">待处理单</el-menu-item> -->
              <el-menu-item index="/index/allOrders">我的订单</el-menu-item>
            </el-submenu>
            <el-submenu index="-1"
                        v-if="userRole!='user'">
              <template slot="title">
                <i class="el-icon-user-solid"></i>
                <span>管理</span>
              </template>
              <el-menu-item index="/index/manageOrders"
                            v-if="accessLevel.orderAdmini">订单管理</el-menu-item>
              <el-menu-item index="/index/seoWeb"
                            v-if="accessLevel.marketingAdmini">营销管理</el-menu-item>
              <el-menu-item index="/index/StoreManagement"
                            v-if="accessLevel.warehousegAdmini">仓库管理</el-menu-item>
              <!-- <el-menu-item index="/index/StoreManagement"
                            v-if="ckManagement">仓库管理</el-menu-item> -->
              <!-- <el-menu-item index="/index/ComeInAndGoOut"
                            v-if="ckManagement">出入库管理</el-menu-item> -->
              <!-- <el-menu-item index="/index/packList"
                            v-if="ckManagement">打包管理</el-menu-item> -->
              <el-menu-item v-if="accessLevel.billAdmini"
                            index="/index/ManagementBills">管理账单</el-menu-item>
              <el-menu-item v-if="accessLevel.monthlyAdmini"
                            index="/index/monthlyBill">月结账单</el-menu-item>
              <el-menu-item index="/index/promotionAudit"
                            v-if="accessLevel.promotionAudit">推广审核</el-menu-item>
              <el-menu-item index="/index/Audit"
                            v-if="accessLevel.auditAdmin">处理审核</el-menu-item>
            </el-submenu>

            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-money"></i>
                <span>财务</span>
              </template>
              <el-menu-item index="/index/myBill">我的账单</el-menu-item>
              <el-menu-item index="/index/myMonthlyBile"
                            v-if="isMonthly">我的月结</el-menu-item>

              <!-- <el-menu-item index="3-4">我的券包</el-menu-item> -->
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-s-tools"></i>
                <span>设置</span>
              </template>
              <el-menu-item index="/index/Userinfo">个人中心</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-row>
    </el-scrollbar>

    <!-- 顶部结构 -->
    <el-container class="container_main">
      <el-header style="text-align: right; font-size: 12px; height：40px">
        <div>
          <el-button type="primary"
                     size="small"
                     @click="pageSkip('placeOrder')"> <i class=" el-icon-house"></i> 下单首页</el-button>
          <el-button type="primary"
                     size="small"
                     @click="pageSkip('LogisticsInfo')"> <i class="el-icon-search "></i> 我要查件</el-button>
          <el-button type="primary"
                     size="small"
                     @click="pageSkip('Inquire')"> <i class="el-icon-view"></i> 我要查价</el-button>
          <el-button type="primary"
                     size="small"
                     @click="serviceInfo_show.flag = true"> <i class="el-icon-headset"></i> 联系客服</el-button>
        </div>
        <div class="heder_right">
          <div class="inform"
               @click="isShowMessage=!isShowMessage">
            <i class="el-icon-message-solid"></i>
            通知
            <i class="el-icon-arrow-down"
               style="margin-left: 5px"></i>

          </div>
          <message-view v-show="isShowMessage"
                        key="container"
                        id="container"></message-view>
          <div>
            <el-dropdown>
              <span class="user_text">
                <i class="el-icon-user-solid"
                   style="margin-right: 10px;"></i>
                <span style="margin-right: 15px;">{{$store.state.userInfo?$store.state.userInfo.name:''}}</span>
                <i class="el-icon-arrow-down"
                   style="margin-right: 15px"></i>
              </span>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native='userMessage()'>个人界面</el-dropdown-item>
                <!-- <el-dropdown-item>新增</el-dropdown-item> -->
                <el-dropdown-item @click.native="user_out()">退出账号</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>
      <div class="childComponents">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>

    </el-container>
  </el-container>
</template>

<script>
import service from '../components/service'
import { apiUserOut, apiUserData } from "../request/api";
import { Message } from "element-ui";
import messageView from '../components/messageView.vue'
import common from '../assets/js/common'
export default {

  name: 'Main',
  data () {
    return {
      isShowMessage: false,
      serviceInfo_show: {
        flag: false
      },
      userName: localStorage.getItem('User'),
      permission: '',

      //是否具有客服权限
      orderManagement: false,
      //是否具有月结
      isMonthly: false,
      //权限等级
      accessLevel: {
        show: false,
        orderAdmini: false,
        marketingAdmini: false,
        billAdmini: false,
        monthlyAdmini: false,
        promotionAudit: false,
        auditAdmin: false
      },
      // -------- 用户权限 --------
      userRole: 'user'
    }
  },
  computed: {

  },
  methods: {
    //   权限初始化
    accessInitialize (level) {
      this.userRole = level
      switch (level) {
        case 'admin':
          this.accessLevel = {
            show: false,
            orderAdmini: true,
            marketingAdmini: true,
            billAdmini: true,
            monthlyAdmini: true,
            promotionAudit: true,
            auditAdmin: true
          }
          break;
        case 'fd':
          this.accessLevel = {
            show: false,
            orderAdmini: true,
            marketingAdmini: false,
            billAdmini: true,
            monthlyAdmini: true,
            promotionAudit: false,
            auditAdmin: true,
          }
          break;
        case 'kf':
          this.accessLevel = {
            show: false,
            orderAdmini: true,
            marketingAdmini: false,
            billAdmini: false,
            monthlyAdmini: false,
            promotionAudit: true,
            auditAdmin: false
          }
          break;
        case 'sales':
          this.accessLevel = {
            show: false,
            orderAdmini: false,
            marketingAdmini: true,
            billAdmini: false,
            monthlyAdmini: false,
            promotionAudit: false,
            auditAdmin: false
          }
          break;
        default:
          break;
      }
    },
    //   页面跳转
    pageSkip (name) {
      this.$router.push({
        name
      })
    },
    //进入用户界面
    userMessage () {
      this.$router.push({
        path: '/index/Userinfo'
      })
    },
    user_out () {
      let _this = this
      apiUserOut({
        vue: 1
      }).then(res => {
        this.$store.commit('removerData')
        if (this.$route.path == '/index/BillingDetails') {
          this.$router.replace({
            path: '/login',
            query: {
              redirect: window.location.href
            }
          });
        } else {
          this.$router.replace('/login')
        }

        Message({
          message: "您已退出账号,请登入",
          type: "success",
        });
      })
    },
    async getNavData () {
      const resp = await apiUserData({
        uid: this.$store.state.uid,
        permission: 1
      })
      if (resp == undefined || resp.errno == 1) {
        this.user_out()
      }
      else {
        this.accessInitialize(resp.role)
        this.$store.commit('upJurisdiction', resp.permission)
        this.$store.commit('upMember', resp.member)
        this.$store.commit('upUserInfo', resp.userinfo)
        this.permission = resp.permission
        if (resp.userinfo.paytype == 2) {
          this.isMonthly = true
        }

        if (resp.role === 'admin') {
          this.orderManagement = true
          this.ckManagement = true
        } else {
          this.orderManagement = common.isOrderManagement(resp.permission, 'orderadmin')
          this.ckManagement = common.isOrderManagement(resp.permission, 'ck')
        }
      }

    }
  },
  components: {
    service,
    messageView
  },
  mounted () {
    this.$nextTick(() => {
      document.addEventListener('mouseup', (e) => {
        let tree = document.querySelector('#container')
        let tree_ = document.querySelector('.el-message-box')
        let falg = tree ? !tree.contains(e.target) : false
        let falg_ = tree_ ? !tree_.contains(e.target) : false
        if (falg && falg_) {
          this.isShowMessage = false
        }
      })
    })
  },
  created () {
    this.getNavData()
  },

};
</script>

<style lang='scss'>
@import "../assets/css/variable.scss";
.el-menu-vertical-demo {
  width: 100%;
  .el-menu-item {
    min-width: 0 !important;
  }
}
body .el-scrollbar__wrap {
  overflow-x: hidden;
}
.container_main {
  width: 90%;
  background-color: #edf0f3;
  .el-header {
    display: flex;
    justify-content: space-between;
    .heder_right {
      position: relative;

      display: flex;
      .inform:hover {
        color: #409eff;
      }
      .inform {
        cursor: pointer;
        margin-right: 40px;
        display: flex;
        align-items: center;
        font-size: 14px;
        .el-icon-message-solid {
          margin-right: 10px;
        }
      }
    }
  }
}
.scro_nav {
  width: 10%;
}
.el-submenu__title:hover {
  background-color: #2486b9 !important;
}
.el-menu-item:hover {
  background-color: #409eff !important;
}
.el-submenu__title i {
  color: #fff !important;
}
.logo {
  width: 100% !important;
  height: 56px;
  text-align: center;
  padding-top: 20px !important;
}
.logo img {
  width: 50px;
  height: 50px;
}
.tac {
  background-color: $userColor;
  height: 100vh;
  margin: 0 !important;
}
.el-col-12 {
  width: 100% !important;
}
.el-menu {
  border-right: 0 !important;
}

/* 顶部样式 */

.user_text {
  color: #333;
}
.user_text i {
  color: #333;
}
.el-header {
  background-color: #fff;
  border-bottom: 2px solid #eee;
  color: #333;
  line-height: 60px;
}
.el-aside {
  color: #333;
}

/* 模块 */
.childComponents {
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  background-color: #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>